import { batch, computed, signal } from '@preact/signals-react'
import { stringToDate } from '@ui-seeker/utils'
import { parseBackendDate } from '@utils'

import {
	acriss,
	categories,
	currency,
	endHour,
	fuelPolicy,
	howToGroup,
	insurance,
	inTerminal,
	lengthRental,
	mainProvider,
	mainSite,
	mileage,
	offices,
	officesPickoff,
	prepaid,
	providers,
	rentalDates,
	rentalLength,
	reports,
	sites,
	startHour,
	tiers,
	transmission,
} from '@signals'
import { currentPeriod, endDate, prevEndDate, prevStartDate, singleDate, startDate } from './date'
import { includeProviders, priceKpi } from './searchConfig'


export const isLoadingCommonFilters = signal(false)
export const showFeatures = signal(false)
export const errors = signal({})
export const disableButton = signal(true)
export const showDropoffOffice = signal(false)

// Computed
export const commonFiltersValue = computed(() => ({
	startDate: startDate.value,
	endDate: endDate.value,
	startHour: startHour.value,
	endHour: endHour.value,
	rentalDates: rentalDates.value,
	prevStartDate: prevStartDate.value,
	prevEndDate: prevEndDate.value,
	singleDate: singleDate.value,
	rentalLength: rentalLength.value,
	priceKpi: priceKpi.value,
	includeProviders: includeProviders.value,
	offices: offices.value,
	officesPickoff: officesPickoff.value,
	sites: sites.value,
	lengthRental: lengthRental.value,
	categories: categories.value,
	providers: providers.value,
	tiers: tiers.value,
	currency: currency.value,
	acriss: acriss.value,
	mileage: mileage.value,
	transmission: transmission.value,
	fuelPolicy: fuelPolicy.value,
	insurance: insurance.value,
	prepaid: prepaid.value,
	inTerminal: inTerminal.value,
	siteMainID: mainSite.value,
	providerMainID: mainProvider.value
}))
export const commonFiltersShareValue = computed(() =>
	Object.entries(commonFiltersValue.value).reduce((acc, [key, value]) => {
		if (value === undefined || value === null || value === '') return acc
		if (Array.isArray(value) && !value.length) return acc
		return { ...acc, [key]: value }
	}, {
		currentPeriod: currentPeriod.value
	})
)

// Functions
export const setCommonFilters = filters => {
	return batch(() => {
		offices.value = filters.id_office_pickup
		officesPickoff.value = filters.id_office_dropoff
		sites.value = filters.id_site
		startHour.value = stringToDate(filters.time_from, 'HH:mm')
		endHour.value = stringToDate(filters.time_to, 'HH:mm')
		rentalDates.value = filters.pickup_date.map(parseBackendDate).filter(Boolean)
		singleDate.value = parseBackendDate(filters.pickup_date[0])
		rentalLength.value = filters.lor
		currency.value = filters.id_currency
	})
}

export const resetCommonFilters = () => batch(() => {
	reports.value = null
	offices.value = null
	officesPickoff.value = null
	sites.value = null
	rentalDates.value = []
	rentalLength.value = []
	howToGroup.value = null
})